export const debounceEvent = (callback:Function, time: number) => {
    let interval:any;
    //@ts-ignore
    return (...args) => {
      clearTimeout(interval);
      interval = setTimeout(() => {
        interval = null;
        callback(...args);
      }, time);
    }
};export const debounceEvent = (callback:Function, time: number) => {
    let interval:any;
    //@ts-ignore
    return (...args) => {
      clearTimeout(interval);
      interval = setTimeout(() => {
        interval = null;
        callback(...args);
      }, time);
    }
};